import { EnvType } from "../services";
import IApiClient from "../api-client";
import {
  CreateExternalAccessRequest,
  GetExternalAccessNoAuthResponse,
  GetExternalAccessResponse,
  ListExternalAccessesResponse,
  UpdateExternalAccessRequest,
  ValidateExternalAccessRequest,
} from "../Types/access-models";
import { GenericResponseStd } from "../Types/generic-response-std";

interface IAccessApiClient {
  CreateExternalAccess(request: CreateExternalAccessRequest): Promise<GenericResponseStd>;
  UpdateExternalAccess(request: UpdateExternalAccessRequest): Promise<GenericResponseStd>;
  RevokeExternalAccess(id: number): Promise<GenericResponseStd>;
  ListExternalAccesses(): Promise<ListExternalAccessesResponse>;
  ListExternalAccessesByObjectId(objectId: number): Promise<ListExternalAccessesResponse>;
  GetExternalAccessNoAuth(key: string): Promise<GetExternalAccessNoAuthResponse>;
  ValidateExternalAccess(request: ValidateExternalAccessRequest): Promise<GenericResponseStd>;
}

export default class AccessApiClient implements IAccessApiClient {
  readonly servicePort = 9528;
  readonly serviceBaseUrl = "access-service/api";

  externalAccessApiClient: IApiClient;

  constructor(logApiClient: IApiClient, envType: EnvType) {
    this.externalAccessApiClient = logApiClient;
    if (envType === "local") this.externalAccessApiClient.client.defaults.baseURL += `${this.servicePort}/`;
  }
  async CreateExternalAccess(request: CreateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.post(`${this.serviceBaseUrl}/external`, request);
  }
  async UpdateExternalAccess(request: UpdateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.put(`${this.serviceBaseUrl}/external`, request);
  }
  async RevokeExternalAccess(id: number): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.delete(`${this.serviceBaseUrl}/external/${id}`);
  }
  async ListExternalAccesses(): Promise<ListExternalAccessesResponse> {
    return await this.externalAccessApiClient.get(`${this.serviceBaseUrl}/external/list`);
  }
  async ListExternalAccessesByObjectId(objectId: number): Promise<ListExternalAccessesResponse> {
    return await this.externalAccessApiClient.get(`${this.serviceBaseUrl}/external/list/object/${objectId}`);
  }
  async GetExternalAccessNoAuth(key: string): Promise<GetExternalAccessNoAuthResponse> {
    return await this.externalAccessApiClient.get(`${this.serviceBaseUrl}/external/key/${key}/no-auth`);
  }
  async ValidateExternalAccess(request: ValidateExternalAccessRequest): Promise<GenericResponseStd> {
    return await this.externalAccessApiClient.post(`${this.serviceBaseUrl}/external/validate/`, request);
  }

  //------Utils------
  GetApiUrl(): string {
    return this.externalAccessApiClient.client.defaults.baseURL + this.serviceBaseUrl;
  }
}
